// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"79":"Claims-Telecom-Start","5521":"Claims-PowerGas-Form","6319":"Claims-Telecom-Form"}[chunkId] + "." + {"79":"00c3db8c","5521":"b87c7cb0","6319":"b87c7cb0"}[chunkId] + ".chunk.css";
};